import { render, staticRenderFns } from "./GuestList.vue?vue&type=template&id=bf03396c"
import script from "./GuestList.vue?vue&type=script&lang=js"
export * from "./GuestList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports